import { ReactComponent as IconInformation } from "@/assets/svgs/information-circle.svg";
import { ButtonType, ButtonVariant } from "@/componentsDS/Button/Button.type";
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Button from "@/componentsDS/Button/Button";
import Modal from "@/componentsDS/Modal/Modal";
import PropTypes from "prop-types";

export const DeleteModelTerm = ({
	isModalVisible,
	hideModal,
	onDeleteHandler,
	termClauseCount
}) => {
	return (
		<Modal visible={isModalVisible} variant="small" close={hideModal}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__icon card-configure__rounded-square card-configure__icon--error card-configure__title__left">
									<IconInformation />
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										<div className="card-configure__title__right__top__title">
											Delete Template
										</div>
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="action-modal__text">
							Delete eBL Template? {termClauseCount === 1 ? ' Issuance will be disabled if there is no Model Terms for ETR.' : ' This action is irreversible.'}
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Left>
						<Button
							onClick={hideModal}
							text="Cancel"
							type={ButtonType.GHOST}
							variant={ButtonVariant.DESTRUCTIVE}
						/>
					</CardConfigure.Footer.Left>
					<CardConfigure.Footer.Right>
						<Button
							onClick={onDeleteHandler}
							text="Confirm"
							type={ButtonType.SOLID}
							variant={ButtonVariant.DESTRUCTIVE}
							className="account-settings__modal_term-action"
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	);
};

DeleteModelTerm.propTypes = {
	isModalVisible: PropTypes.bool.isRequired,
	hideModal: PropTypes.func.isRequired,
	onDeleteHandler: PropTypes.func.isRequired,
	termClauseCount: PropTypes.number
};